import BaseUser from "@/project/model/base/BaseUser";

export default class BaseUserBetweenTime extends BaseUser {

    startTime = '';
    endTime = '';

}